import { CameraFilled } from '@ant-design/icons';
import classnames from 'classnames';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCaptureState } from '../context';

const SnapshotIcon = ({
  disabled,
  title,
  className = '',
}: {
  disabled: boolean;
  title: string;
  className?: string;
}) => {
  const { t } = useTranslation('Vindoc');
  const { isFullScreen, handleSnapshot } = useCaptureState();

  const onSnapshot = useCallback(() => {
    if (disabled) return;

    handleSnapshot?.();
  }, [disabled, handleSnapshot]);

  return (
    <CameraFilled
      onClick={onSnapshot}
      className={classnames(
        'absolute left-[8px] bottom-[6px] rounded-full bg-[#fafafa24] p-3 text-[26px] drop-shadow-lg hover:bg-[#fafafa2b]',
        className,
        {
          'disabled cursor-not-allowed opacity-50': disabled,
          'sm:text-[20px] lg:text-[28px]': isFullScreen,
        }
      )}
      disabled={disabled}
      title={t(title)}
      style={{
        transition: 'background 0.2s ease-out',
        willChange: 'background',
      }}
    />
  );
};

export default memo(SnapshotIcon);
